<section
  class="shimmer-beam"
  [class.is-fallback]="reducedMotion"
  [class.is-horizontal]="direction === 'horizontal'"
  [style.height]="height"
  [style.--scene-speed-input]="speed"
  [style.--scene-intensity-input]="intensity"
>
  <div class="beam-base"></div>
  <div class="beam-sweep beam-sweep-primary"></div>
  <div class="beam-sweep beam-sweep-secondary"></div>
</section>
